var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 47969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6667 4H6.33333C4.49533 4 3 5.5701 3 7.5V14.5C3 16.4299 4.49533 18 6.33333 18H15.6667C17.5047 18 19 16.4299 19 14.5V7.5C19 5.5701 17.5047 4 15.6667 4ZM6.33333 5.4H15.6667C16.7693 5.4 17.6667 6.3422 17.6667 7.5H4.33333C4.33333 6.3422 5.23067 5.4 6.33333 5.4ZM4.33333 14.5V8.9H7.66667V16.6H6.33333C5.23067 16.6 4.33333 15.6578 4.33333 14.5ZM15.6667 16.6H9V8.9H17.6667V14.5C17.6667 15.6578 16.7693 16.6 15.6667 16.6Z",
    fill: "#26445A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.09b248355ce958e8a478cdcafdd287d6.svg";
export { ForwardRef as ReactComponent };